export default __webpack_public_path__ + "static/pultrudedfrp4-68ce26d06776548d3e54672d749ce73d.jpg";